<template>
  <div>
    <div class="search-left">
      <div class="search-lf-tl">{{ $t('assist.header.title') }}</div>
      <div class="search-lf-rt">{{ $t('assist.header.notes') }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {}
  },
})
</script>

<style lang="less" scoped>
.search-left {
  display: flex;
  flex: 1;
  .search-lf-tl {
    font-size: 22px;
    font-weight: 600;
    color: #303133;
  }
  .search-lf-rt {
    font-size: 12px;
    color: #6b727f;
    margin-left: 5px;
    margin-top: 5px;
  }
}
.mobile-viewport {
  .search-lf-tl {
    font-size: 15px;
  }
  .search-lf-rt {
    display: none;
  }
}
</style>

